import ComponentView from './ComponentView';

export default ComponentView.extend({
  initialize() {
    ComponentView.prototype.initialize.apply(this, arguments);
  },

  // Clear methods used on Nodes with attributes
  _setAttributes() {},
  renderAttributes() {},
  setAttribute() {},
  updateAttributes() {},
  initClasses() {},
  initComponents() {},
  delegateEvents() {},

  _createElement() {
    return document.createTextNode('');
  },

  render() {
    const { model, el } = this;
    if (model.opt.temporary) return this;
    el.textContent = model.get('content');
    return this;
  }
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/dom_components/view/ComponentTextNodeView.js